<template>
  <div class="lg:flex px-4 mb-20 lg:mb-40">
    <div class="w-full lg:w-[651px] mr-14">
      <div>
        <div class="text-title text__headline-4-xs--bold lg:text__headline-3-md--bold">
          {{ tutorSelection.title }}
        </div>
      </div>
      <div class="mt-4 lg:mt-6">
        <div class="text-body-1 text__body-2--md--regular custom-html-content" v-html="tutorSelection.description" />
      </div>
    </div>
    <div class="mx-auto flex justify-center">
      <img
        data-src="@images/public/how-it-work/tutor-selection.png"
        class="lazyload mx-auto w-full lg:w-auto lg:h-[345px]"
        :alt="tutorSelection.title"
      >
    </div>
  </div>
</template>
<script>
import staticData from './static-data'

export default {
  name: 'TutorSelection',
  data () {
    return {
      tutorSelection: staticData.component.TutorSelection
    }
  }
}
</script>
<style scoped lang="scss">
.custom-html-content {
  ::v-deep {
    ul {
      list-style-type: disc;
      padding-left: 1.5em;
      }
  }
}
</style>
